<template>
  <div class="content">
    <div class="top-content">
      <div class="card-box">
        <div class="item" :class="{ active: type == 1}" @click="changeType(1)">
          <span class="money">¥{{ customerWechatSum.totalAmount || 0}}</span>
          <span class="title">已核销金额</span>
        </div>
        <div class="item" :class="{ active: type == 2}" @click="changeType(2)">
          <span class="money">¥{{ customerWechatSum.waitVerifyAmount || 0}}</span>
          <span class="title">待核销金额</span>
        </div>
        <div class="item" :class="{ active: type == 3}" @click="changeType(3)">
          <span class="money">¥{{ customerWechatSum.refundAmount || 0}}</span>
          <span class="title">已退款金额</span>
        </div>
        <div class="item" :class="{ active: type == 4}" @click="changeType(4)">
          <span class="money">¥{{ customerWechatSum.extractedCash || 0}}</span>
          <span class="title">已提现金额</span>
        </div>
        <div class="item" :class="{ active: type == 5}" @click="changeType(5)">
          <span class="money">¥{{ customerWechatSum.refundFrozenAmount || 0}}</span>
          <span class="title">退款冻结金额</span>
        </div>
      </div>
      <div class="title-box">
        <div class="top-box">
          <span class="title">{{ mapTitle[type].title }}</span>
          <span class="export" @click="exportFile">导出数据 ></span>
        </div>
        <div class="subtitle">{{ mapTitle[type].subtitle }}</div>
      </div>
    </div>

    <van-sticky>
      <div class="list-box">
        <mescroll-vue
          ref="mescroll"
          :down="mescrollDown"
          :up="mescrollUp"
          class="scroll"
          @init="mescrollInit"
        >
          <div id="content" class="list-content">
            <div class="row" v-for="(item, index) in list">
              <div class="row-top">
                <span>{{ item.userName }}</span>
                <span>¥{{ item.settlementAmount }}</span>
              </div>
              <div class="row-bottom" v-if="type == 1">核销时间 {{ item.verificationTime }}</div>
              <div class="row-bottom" v-if="type == 2">下单时间 {{ item.buyTime }}</div>
              <div class="row-bottom" v-if="type == 3">退款时间 {{ item.refundTime }}</div>
              <div class="row-bottom" v-if="type == 4">提现时间 {{ item.buyTime }}</div>
              <div class="row-bottom" v-if="type == 5">申请退款时间 {{ item.refundTime }}</div>
            </div>
          </div>
        </mescroll-vue>
      </div>
    </van-sticky>
  </div>
</template>

<script>
  import MescrollVue from 'mescroll.js/mescroll.vue'
  import noDataImg from "@/assets/images/img-default@2x.png";
  export default {
   components: { MescrollVue },
    props: {
      dateParmes: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        mescroll: null,
        mescrollDown: {
          callback: this.init,
        },
        mescrollUp: {
          callback: this.getList,
          page: {
            num: 1,
            size: 10
          },
          htmlNodata: '<p class="upwarp-nodata">-- 没有更多数据了 --</p>',
          noMoreSize: 1,
          empty: {
            // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
            warpId: 'content', // 父布局的id;
            icon: noDataImg, // 图标,支持网络图
            tip: '暂无数据', // 提示
          },
        },
        list: [],
        customerWechatSum: {},
        type: 1,
        isClick: true,
        mapTitle: {
          1: {title: '已核销订单金额明细', subtitle: '(报名时间不限，但核销时间在筛选时间内的已核销订单)'},
          2: {title: '待核销订单金额明细', subtitle: '(报名时间在筛选时间内的未核销订单)'},
          3: {title: '已退款金额订单明细', subtitle: '(仅统计已核销已退款订单,退款时间在筛选时间内的已退款订单)'},
          4: {title: '已提现金额记录明细'},
          5: {title: '退款冻结订单明细', subtitle: '(仅统计已核销申请退款待退款订单,申请退款时间在筛选时间内)'},
        }
      }
    },
    mounted() {
      this.queryCustomerWechatSum()
    },
    methods: {
      queryCustomerWechatSum() {
        this.$api.withdrawal.queryCustomerWechatSum(this.dateParmes).then(res => {
          if (res.data) {
            this.customerWechatSum = res.data
          }
        })
      },
      init() {
        this.list = []
        // 下拉刷新的回调; 默认重置上拉加载列表为第一页
        this.mescroll.resetUpScroll()
      },
      mescrollInit(mescroll) {
        this.mescroll = mescroll
      },
      getList(page, mescroll) {
        const parames = {
          filterData: {
            type: this.type,
            ...this.dateParmes
          },
          pageNum: page.num,
          pageSize: page.size,
        }
        this.$api.withdrawal.queryCustomerWechatOrderList(parames)
          .then(res => {
            if (res.success) {
              const {list, hasNextPage } = res.data
              this.list.push(...list);
              mescroll.endSuccess(this.list.length, hasNextPage)
            }
          })
      },
      changeType(type) {
        this.type = type 
        this.list = []
        this.pageNum = 1
        this.finished = false
        this.init()
      },
      dateSearch() {
        this.list = []
        this.pageNum = 1
        this.finished = false
        this.$nextTick(()=>{
          this.queryCustomerWechatSum()
          this.init()
        })
      },
      exportFile() {
        if (this.isClick){
          let map = { 1: 21, 2: 22, 3: 23, 4: 24, 5: 25 }
          this.isClick = false
          const { startDate = '',endDate = '' } = this.dateParmes
          const parames = {
            type: map[this.type],
            startTime: startDate,
            endTime: endDate,
          }
          this.$api.activityMgmt.dataExport(parames)
            .then((res) => {
              if (res.success) {
                this.$dialog.confirm({
                  title: '下载提示',
                  message:`因数据较大正在处理中，请稍后到<br/>我的-导出列表中下载数据`,
                  cancelButtonText: '确定',
                  confirmButtonText: '去往-导出列表'
                }).then(_ =>{
                  this.$router.push({
                    path: '/export-list'
                  })
                })
              }
            }).finally(_ => {
              setTimeout(() => {
                this.isClick = true
              },500)
            })
        }
      },
    }
  }
</script>

<style lang="stylus" scoped>
  .content {
    .top-content {
      padding: 0 15px;
      .card-box {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap; 
      
        .item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 165px;
          height: 86px;
          background: #F4F4F4;
          border-radius: 13px;
          margin-top: 15px;
          border: 1px solid transparent;
          .money {
            font-size: 20px;
            font-weight: bold;
          }
          .title {
            color: 16px;
            margin-top: 2px;
          }
        }
        .active {
          color: #FF6B31;
          border: 1px solid #FF6B31;
          background: #FFF2ED;
        }
      }
      .title-box {
        padding: 8px 0;
        height: 40px;
        margin-top: 8px;
        .top-box {
          display: flex;
          justify-content: space-between;
          font-size: 15px;
          .title {
            color: #333333;
            font-weight: 500;
          }
          .export {
            color: #666666;
          }
        }
        .subtitle {
          font-size: 12px;
          margin-top: 4px;
        }
      }
    }
    .list-box {
      padding: 0 15px;
      height: 91vh;
      overflow-y: auto;
      background: #fff;
      .list-content {
        .row {
          padding: 15px 0;
          border-bottom: 1px solid #E5E5E5;
          .row-top {
            display: flex;
            justify-content: space-between;
            color: #333333;
            font-size: 16px;
          }
          .row-bottom {
            color: #999999;
            font-size: 13px;
            margin-top: 3px;
          }
        }
      }
    }
  }
</style>